module.exports = __webpack_public_path__ + "static/media/statuss_in_progress.9bd4b05f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/statuss_in_progress.jpg
// module id = 1882
// module chunks = 0